import React, { useMemo } from 'react';
import { Checkbox } from '@mui/material';

import CloseIcon from '../../assets/images/common/close.svg';

import { MasterSlaApiResponse } from '../../types/api/MasterSlaApiType';
import { MasterPrefectureApiResponse } from '../../types/api/MasterPrefectureApiType';
import { DeviceInfoRow, EstimatePattern, SetStateEstimate } from '../../types/common/EstimateInquiryType';

import { EditEstimateRowEdit } from './EditEstimateRowEdit';

type EditEstimateRowProps = {
    setState: SetStateEstimate;
    rowNumber: number;
    masterPrefecture: MasterPrefectureApiResponse;
    masterSla: Array<MasterSlaApiResponse>;
    estimatePattern: EstimatePattern;
    inputMode: boolean;
    patternListLength: number;
    deviceList: DeviceInfoRow[];
};

export const EditEstimateRow: React.FC<EditEstimateRowProps> = ({
    setState,
    rowNumber,
    masterPrefecture,
    masterSla,
    estimatePattern,
    inputMode,
    patternListLength,
    deviceList,
}) => {
    // select 保守レベル
    const slaList: Array<MasterSlaApiResponse> = useMemo<Array<MasterSlaApiResponse>>(() => masterSla, []);

    return (
        <>
            <div className='edit-estimate-row'>
                <div className='edit-estimate-title'>
                    <h3>
                        <label className='label required'>見積り条件{rowNumber}</label>
                    </h3>
                    <input
                        type='text'
                        className='edit-estimate-pattern-input'
                        placeholder='見積名を入力してください。 例：検証環境用'
                        value={estimatePattern.estimatePatternName}
                        onChange={(e) =>
                            setState.setStateEstimatePattern({
                                ...estimatePattern,
                                estimatePatternName: e.target.value,
                            })
                        }
                        disabled={!inputMode}
                    />
                    <div className='edit-estimate-row-icon'>
                        {patternListLength > 1 && inputMode ? (
                            <span className='icon is-small'>
                                <img
                                    src={CloseIcon}
                                    alt=''
                                    onClick={() =>
                                        setState.deleteStateEstimatePattern(estimatePattern.estimatePatternRowNumber)
                                    }
                                />
                            </span>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                {inputMode ? (
                    <>
                        <Checkbox
                            id={`device-checkitem-all-${estimatePattern.estimatePatternRowNumber}`}
                            checked={estimatePattern.checkAllFlag}
                            disabled={!inputMode}
                            onChange={(event) =>
                                setState.setStateEstimateDetailCheckFlagAll(
                                    event.target.checked,
                                    estimatePattern.estimatePatternRowNumber
                                )
                            }
                        />
                        <label htmlFor={`device-checkitem-all-${estimatePattern.estimatePatternRowNumber}`}>
                            全選択/全解除
                        </label>
                    </>
                ) : (
                    <></>
                )}
                {estimatePattern.estimateList.map((estimate, index) => {
                    return (
                        <React.Fragment
                            key={`editEstimateRow-estimateList-${estimatePattern.estimatePatternRowNumber}-${estimate.inputRowNumber}-${index}`}
                        >
                            <EditEstimateRowEdit
                                estimatePatternRowNumber={estimatePattern.estimatePatternRowNumber}
                                masterPrefecture={masterPrefecture}
                                slaList={slaList}
                                estimate={estimate}
                                setStateEstimateDetail={setState.setStateEstimateDetail}
                                inputMode={inputMode}
                                deviceList={deviceList}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};
